import { z } from 'zod';
import { ErrorTypes } from '../../../utils/constants.js';
import { baseStructureSchema } from './base.structure.js';
import { blockSchema } from './block.js';

var QuestionDisplayVariant = /* @__PURE__ */ ((QuestionDisplayVariant2) => {
  QuestionDisplayVariant2["SINGLE_BLANK"] = "single_blank";
  QuestionDisplayVariant2["BOX"] = "box";
  return QuestionDisplayVariant2;
})(QuestionDisplayVariant || {});
const blankStructureSchema = baseStructureSchema.extend({
  query: blockSchema.refine((query) => {
    const hasMedia = query.media?.length > 0;
    if (hasMedia) {
      return true;
    }
    if (!query.text) {
      return false;
    }
    const regex = /<[^>]+>/g;
    const cleanedText = query.text.replace(regex, "").trim();
    const hasLatex = query.text.includes("<katex");
    return cleanedText.length > 0 || hasLatex;
  }, {
    message: ErrorTypes.EMPTY_QUERY
  }),
  answer: z.literal(0),
  marks: z.object({
    correct: z.number().min(1).max(20)
  }).optional(),
  options: z.array(blockSchema).min(1, {
    message: ErrorTypes.INVALID_ANSWER
  }),
  settings: z.object({
    questionDisplayVariant: z.nativeEnum(QuestionDisplayVariant).optional(),
    ignoreAccentMarksForEvaluation: z.boolean().default(false),
    enableAccentMarks: z.boolean().default(false),
    questionMetadata: z.object({
      answerLength: z.number().optional(),
      specialIndices: z.array(
        z.object({
          index: z.number(),
          char: z.string()
        })
      ).optional()
    }).optional()
  })
});

export { QuestionDisplayVariant, blankStructureSchema };
